const _excluded = ["hasActionButton", "closeOnOutsideClick", "onRenderFooter", "enableEventBubbling"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Panel as FabricPanel, mergeStyleSets, PanelType, Stack } from 'office-ui-fabric-react';
import { DefaultButton } from '../Button/Default';
import { PrimaryButton } from '../Button/Primary';
import { Spinner, SpinnerSize } from '../Spinner';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const panelStyles = {
  content: {
    marginTop: 10
  },
  footerInner: {
    padding: '0 24px'
  }
};
export const AsidePanel = _ref => {
  let {
      hasActionButton = true,
      closeOnOutsideClick = true,
      onRenderFooter,
      enableEventBubbling
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const footerWrapperStyles = {
    root: {
      marginBottom: 10
    }
  };
  const renderCancelButton = () => /*#__PURE__*/_jsx(DefaultButton, {
    onClick: props.onCancelClick,
    "data-id": "cancel-button",
    children: "Cancel"
  });
  const renderActionButton = () => /*#__PURE__*/_jsxs(PrimaryButton, {
    onClick: props.onConfirmClick,
    disabled: props.isActionButtonDisabled,
    "data-id": "confirm-button",
    children: [props.isLoading && /*#__PURE__*/_jsx(Spinner, {
      size: SpinnerSize.small,
      styles: {
        root: {
          marginRight: 8
        }
      }
    }), props.actionButtonName]
  });
  const temp = {
    tokens: {
      childrenGap: 8
    }
  };
  const renderDefaultActionButtons = () => /*#__PURE__*/_jsxs(Stack, _objectSpread(_objectSpread({
    horizontal: true,
    horizontalAlign: "end"
  }, temp), {}, {
    children: [renderCancelButton(), hasActionButton && renderActionButton()]
  }));
  const renderDefaultFooter = renderActionButtons => /*#__PURE__*/_jsx(Stack, {
    styles: footerWrapperStyles,
    children: /*#__PURE__*/_jsx(Stack, {
      horizontal: true,
      horizontalAlign: "end",
      children: renderActionButtons()
    })
  });
  const buttonsRender = () => props.onRenderActionButtons ? () => props.onRenderActionButtons({
    renderActionButton,
    renderCancelButton
  }) : renderDefaultActionButtons;
  const onAddPanelRenderFooterContent = () => onRenderFooter ? onRenderFooter({
    footerWrapperStyles,
    renderActionButtons: buttonsRender()
  }) : renderDefaultFooter(buttonsRender());
  const handleEnterClick = event => {
    if (!props.shouldHandleEnterClick) return;
    if (event.key === 'Enter') {
      event.preventDefault();
      if (props.isOpen && !props.isActionButtonDisabled) {
        props.onConfirmClick && props.onConfirmClick();
      }
    }
  };
  return /*#__PURE__*/_jsx(FabricPanel, {
    customWidth: props.customWidth,
    isOpen: props.isOpen,
    type: props.type,
    onDismiss: props.onCancelClick,
    onRenderFooterContent: onAddPanelRenderFooterContent,
    styles: mergeStyleSets(panelStyles, props.styles),
    headerText: props.headerText,
    headerTextProps: {
      'data-id': "".concat(props.dataId, "-header-text")
    },
    closeButtonAriaLabel: "Close",
    tabIndex: 0,
    onKeyPress: handleEnterClick,
    isFooterAtBottom: true,
    focusTrapZoneProps: props.focusTrapZoneProps,
    "data-id": props.dataId,
    isBlocking: props.isBlocking,
    isLightDismiss: closeOnOutsideClick,
    layerProps: {
      eventBubblingEnabled: enableEventBubbling
    },
    children: props.children
  });
};
AsidePanel.defaultProps = {
  type: PanelType.smallFixedFar,
  actionButtonName: 'Save',
  shouldHandleEnterClick: true
};